import { deleteProperty } from "../../../redux/slices/property";
import { Modal, Box, Typography, Button, AlertColor } from "@mui/material";
import useAppDispatch from "../../../hooks/useAppDispatch";

interface RemovePropertyProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (propertyId: number) => void;
  title?: string;
  description?: string;
  propertyIdToRemove: number;
}

const RemoveModal = ({
  open,
  onClose,
  onConfirm,
  title = "Varmistus",
  description = "Haluatko varmasti poistaa kiinteistön tiekunnasta?",
  propertyIdToRemove,
}: RemovePropertyProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" mb={2}>
          {title}
        </Typography>
        <Typography variant="body1" mb={3}>
          {description}
        </Typography>

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Peruuta
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => onConfirm(propertyIdToRemove)}
          >
            Poista
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RemoveModal;
